var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1611 20H4.16113C3.05656 20 2.16113 19.1046 2.16113 18V5.913C2.20774 4.84255 3.08967 3.99899 4.16113 4H20.1611C21.2657 4 22.1611 4.89543 22.1611 6V18C22.1611 19.1046 21.2657 20 20.1611 20ZM4.16113 7.868V18H20.1611V7.868L12.1611 13.2L4.16113 7.868ZM4.96113 6L12.1611 10.8L19.3611 6H4.96113Z",
    fill: "#ADADAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail_icon.9cfb7a3c6e6258922e9be64ffff90f18.svg";
export { ForwardRef as ReactComponent };